import supabase from '../supabase/supabase';

const PAGE_SIZE=25;

function escapeSearchTerm(value) {
  return String(value || '')
    .trim()
    .replace(/\\/g,'\\\\')
    .replace(/%/g,'\\%')
    .replace(/,/g,'\\,');
}

function buildSearchFilter(search) {
  const term=escapeSearchTerm(search);

  if (!term) {
    return '';
  }

  return [
    `quote_reference.ilike.%${term}%`,
    `client_company.ilike.%${term}%`,
    `quote_title.ilike.%${term}%`,
    `contact_email.ilike.%${term}%`
  ].join(',');
}

export async function loadAdminQuotes({
  archived=false,
  search='',
  page=1
}) {
  const from=(page - 1) * PAGE_SIZE;
  const to=from + PAGE_SIZE - 1;
  const searchFilter=buildSearchFilter(search);

  let query=supabase
    .from('quotes')
    .select(
      'id,quote_reference,client_company,quote_title,project_name,contact_email,base_total_cents,status,created_at,updated_at,archived_at',
      {count: 'exact'}
    )
    .range(from,to);

  query=archived
    ? query.not('archived_at','is',null).order('archived_at',{ascending: false})
    : query.is('archived_at',null).order('updated_at',{ascending: false});

  if (searchFilter) {
    query=query.or(searchFilter);
  }

  const {data,error,count}=await query;

  if (error) {
    throw error;
  }

  return {
    quotes: data || [],
    count: count || 0
  };
}

export async function loadAdminQuoteCounts() {
  const [activeResult,archivedResult]=await Promise.all([
    supabase
      .from('quotes')
      .select('id',{count: 'exact',head: true})
      .is('archived_at',null),
    supabase
      .from('quotes')
      .select('id',{count: 'exact',head: true})
      .not('archived_at','is',null)
  ]);

  if (activeResult.error) {
    throw activeResult.error;
  }

  if (archivedResult.error) {
    throw archivedResult.error;
  }

  return {
    activeCount: activeResult.count || 0,
    archivedCount: archivedResult.count || 0
  };
}

export async function archiveQuote(quoteId) {
  const {data,error}=await supabase
    .from('quotes')
    .update({archived_at: new Date().toISOString()})
    .eq('id',quoteId)
    .select('id,archived_at')
    .single();

  if (error) {
    throw error;
  }

  return data;
}

export async function restoreQuote(quoteId) {
  const {data,error}=await supabase
    .from('quotes')
    .update({archived_at: null})
    .eq('id',quoteId)
    .select('id,archived_at')
    .single();

  if (error) {
    throw error;
  }

  return data;
}

export {PAGE_SIZE};